// Quick Dataset Test
// Run this in browser console to quickly test the dataset

export const quickDatasetTest = async () => {
  console.log('🧪 QUICK DATASET TEST');
  console.log('==================');
  
  try {
    // Test 1: Check if JSON file is accessible
    console.log('📡 Testing JSON file access...');
    const response = await fetch('/events_master_with_format_and_geo.json');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    console.log('✅ JSON file accessible');
    
    // Test 2: Check file size
    const contentLength = response.headers.get('content-length');
    const fileSizeMB = contentLength ? (parseInt(contentLength) / 1024 / 1024).toFixed(2) : 'Unknown';
    console.log(`📊 File size: ${fileSizeMB} MB`);
    
    // Test 3: Parse JSON
    console.log('📄 Parsing JSON...');
    const rawData = await response.json();
    console.log(`✅ JSON parsed: ${rawData.length} events`);
    
    // Test 4: Check sample event
    const sampleEvent = rawData[0];
    console.log('🔍 Sample event:', {
      title: sampleEvent.event_title,
      format: sampleEvent.format,
      location: sampleEvent['location/address']
    });
    
    // Test 5: Check format distribution
    const formats = rawData.reduce((acc, event) => {
      acc[event.format] = (acc[event.format] || 0) + 1;
      return acc;
    }, {});
    
    console.log('📈 Format distribution:', formats);
    
    // Test 6: Performance test
    console.log('⚡ Performance test...');
    const startTime = performance.now();
    
    // Simulate processing
    const processedEvents = rawData.map(event => ({
      ...event,
      id: `test-${Math.random()}`,
      categoryPrimary: 'Test',
      categorySecondary: 'Test'
    }));
    
    const endTime = performance.now();
    const duration = endTime - startTime;
    
    console.log(`⏱️ Processing time: ${duration.toFixed(2)}ms`);
    console.log(`🚀 Status: ${duration < 1000 ? '✅ FAST' : '⚠️ SLOW'}`);
    
    // Final results
    console.log('\n🎯 TEST RESULTS:');
    console.log(`✅ ${rawData.length} events loaded`);
    console.log(`✅ ${Object.keys(formats).length} formats found`);
    console.log(`✅ Processing: ${duration.toFixed(2)}ms`);
    console.log(`✅ File size: ${fileSizeMB} MB`);
    
    return {
      success: true,
      eventCount: rawData.length,
      formats: Object.keys(formats),
      processingTime: duration,
      fileSize: fileSizeMB
    };
    
  } catch (error) {
    console.error('❌ TEST FAILED:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Make function available globally
if (typeof window !== 'undefined') {
  window.quickDatasetTest = quickDatasetTest;
  console.log('🧪 Quick test available: quickDatasetTest()');
}




